<template>
    <div>
        <div class="head">
            <el-button type="primary" size="small" style="width: 80px" @click="addBtn">新增</el-button>
        </div>
        <div class="content">
            <el-table
                    :data="deviceManagerList"
                    :header-cell-style="{ background: 'rgb(250,250,250)' }"
                    style="width: 100%">
                <el-table-column label="危险源" align="center" prop="dsMajorHazards.name"/>
                <el-table-column label="装置名称" align="center" prop="deviceName"/>
                <el-table-column label="部门" align="center" prop="department.name"/>
                <el-table-column label="危险等级" align="center" prop="dsMajorHazards.majorHazardsLevel" width="140px">
                    <template slot-scope="{ row }">
                        {{ levelArr[Number(row.dsMajorHazards.majorHazardsLevel) - 1] }}
                    </template>
                </el-table-column>
                <el-table-column label="工艺类型" align="center" prop="processType">
                    <template slot-scope="{ row }">
                        {{ processTypeArr[Number(row.processType) - 1] }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                    <template slot-scope="{ row }">
                        <span class="btn" style="color: #1890ff" @click="editBtn(row)">编辑</span>
                        <span style="margin: 0 5px;color: #e8e8e8">|</span>
                        <span class="btn" style="color: #ff0000" @click="deleteBtn(row)">删除</span>
                    </template>
                </el-table-column>
            </el-table>
            <div style="text-align: right; margin-top: 15px">
                <Page :total="total" :current="curPage" :page-size="pageSize" @on-change="pageChange"/>
            </div>
        </div>

        <!-- 添加或修改风险四色图管理对话框 -->
        <el-dialog :title="title" :visible.sync="open" width="700px" append-to-body>
            <el-form ref="form" :model="form" :rules="rules" label-width="140px">
                <el-form-item label="危险源" prop="dsMajorId">
                    <el-select v-model="form.dsMajorId" placeholder="请选择危险源">
                        <el-option
                                v-for="dict in dsMajorList"
                                :key="dict.id"
                                :label="dict.name"
                                :value="dict.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="装置名称" prop="bName">
                    <el-input v-model="form.deviceName" placeholder="请输入装置名称"/>
                </el-form-item>
                <el-form-item label="部门" prop="departId">
                    <el-select v-model="form.departId" placeholder="请选择部门">
                        <el-option
                                v-for="dict in departList"
                                :key="dict.id"
                                :label="dict.name"
                                :value="dict.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="工艺类型" prop="processType">
                    <el-select v-model="form.processType" style="width: 30%">
                        <el-option :value="1" label="光气及光气化工艺"/>
                        <el-option :value="2" label="氯化工艺"/>
                        <el-option :value="3" label="硝化工艺"/>
                        <el-option :value="4" label="合成氨工艺"/>
                        <el-option :value="5" label="裂解(裂化)工艺"/>
                        <el-option :value="6" label="氟化工艺"/>
                        <el-option :value="7" label="加复工艺"/>
                        <el-option :value="8" label="氧化工艺"/>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="submitForm">确 定</el-button>
                <el-button @click="cancel">取 消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>

    import {
        listDeviceManager,
        getDeviceManager,
        delDeviceManager,
        addDeviceManager,
        updateDeviceManager
    } from "@/api/doublePrevention/deviceManager";
    import {hazardInstallationsList} from "@/api/majorHazard";
    import {deptList} from "@/api/depart"

    export default {
        name: 'DeviceManager',
        data() {
            return {
                // searchContent: '',
                deviceManagerList: [],
                departList: [],
                dsMajorList: [],
                levelArr: ['一级', '二级', '三级', '四级'],
                processTypeArr: [
                    '光气及光气化工艺',
                    '氯化工艺',
                    '硝化工艺',
                    '合成氨工艺',
                    '裂解(裂化)工艺',
                    '氟化工艺',
                    '加复工艺',
                    '氧化工艺'
                ],
                total: 0,
                curPage: 1,
                pageSize: 10,
                open: false,
                form: {},
                rules: {},
                title: null
            }
        },
        created() {
            this.getDeviceManagerList();
            this.getHazardInstallationsList();
            this.getDepartList();
        },
        methods: {
            getDeviceManagerList() {
                listDeviceManager({limit: this.pageSize, curPage: this.curPage, type: 0, isPage: 1}).then(res => {
                    this.deviceManagerList = res.body.data
                    this.total = res.body.cum

                })
            },
            getHazardInstallationsList() {
                hazardInstallationsList().then(res => {
                    this.dsMajorList = res.body.data
                })
            },
            getDepartList() {
                deptList().then(res => {
                    this.departList = res.body.data
                })
            },
            pageChange(val) {
                this.curPage = val;
                this.getDeviceManagerList();
            },
            addBtn() {
                this.reset()
                this.open = true
                this.title = '添加装置设备信息'
            },
            editBtn(row) {
                this.reset()
                const id = row.id
                getDeviceManager(id).then(response => {
                    this.form = response.body.data
                    this.open = true
                    this.title = '修改装置设备信息'
                })
            },
            deleteBtn(row) {
                delDeviceManager(row.id).then(res => {
                    this.$message.success('删除成功')
                    this.getDeviceManagerList()
                })
            },
            // 取消按钮
            cancel() {
                this.open = false
                this.reset()
            },
            // 表单重置
            reset() {
                this.form = {
                    id: null,
                    responsibility: null,
                    bName: null,
                    itemId: null,
                    inspectionitem: null,
                    employeeId: null
                }
            },
            /** 提交按钮 */
            submitForm() {
                this.$refs['form'].validate(valid => {
                    if (valid) {

                        if (this.form.id != null) {
                            updateDeviceManager(this.form).then(response => {
                                this.open = false
                                this.getDeviceManagerList()
                            })
                        } else {
                            addDeviceManager(this.form).then(response => {
                                this.open = false
                                this.getDeviceManagerList()
                            })
                        }
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .head {
        display: flex;
        justify-content: space-between;
        width: calc(100% - 280px);
    }

    .btn {
        cursor: pointer;
    }
</style>





